<!-- Material Select Version -->
<mat-form-field *ngIf="useMaterial && control" [appearance]="appearance" class="form-select-field">
  <mat-label *ngIf="label">{{ label }} <span *ngIf="required" class="required-asterisk">*</span></mat-label>
  
  <mat-select 
    [formControl]="control!"
    [disabled]="disabled"
    [multiple]="multiple"
    (valueChange)="onValueChange($event)"
    (blur)="onBlur()"
    (focus)="onFocus()">
    
    <mat-option *ngFor="let option of options" [value]="option.value" [disabled]="option.disabled">
      {{ option.label }}
    </mat-option>
  </mat-select>

  <!-- Hint -->
  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>

  <!-- Error Message -->
  <mat-error *ngIf="isInvalid">{{ displayError }}</mat-error>
</mat-form-field>

<!-- Standard HTML Version -->
<div *ngIf="!useMaterial && control" class="form-select-group">
  <label *ngIf="label" [for]="id" class="form-select-label">
    {{ label }} <span *ngIf="required" class="required-asterisk">*</span>
  </label>

  <select
    [id]="id"
    class="form-select-field-standard"
    [formControl]="control!"
    [disabled]="disabled"
    [multiple]="multiple"
    (valueChange)="onValueChange($event)"
    (blur)="onBlur()"
    (focus)="onFocus()">
    
    <option *ngIf="!multiple" value="">Select an option</option>
    <option *ngFor="let option of options" [value]="option.value" [disabled]="option.disabled">
      {{ option.label }}
    </option>
  </select>

  <!-- Hint -->
  <div *ngIf="hint" class="form-select-hint">{{ hint }}</div>

  <!-- Error Message -->
  <div *ngIf="isInvalid" class="form-select-error">{{ displayError }}</div>
</div>
